import { useEffect, useState } from "react";
import Swal from "sweetalert2";

import { DateTime } from "luxon";

export default function UsePeritajes(hashParam, selection) {
  const [clientData, setClientData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [hash, setHash] = useState(hashParam);

  const [files, setFiles] = useState([]);

  const [showLoader, setShowLoader] = useState(false);

  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    getClient();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hash]);

  const getClient = async () => {
    try {
      const url = `https://store.lenken.com.ar/lenkenapi/cotizador/cliente/${hash}`;

      const response = await fetch(url);

      let data;

      if (response.status !== 200) {
        Swal.fire({
          text: "error al obtener los datos",
          icon: "error",
        });
      } else {
        data = await response.json();

        const fechaDb = DateTime.fromISO(data.data[0].Fecha);
        const fechaHoy = DateTime.fromJSDate(new Date());

        const days = fechaDb.diff(fechaHoy, "hours").hours / 24;

        if (!(days <= 0 && Math.abs(days) <= 5)) {
          setIsExpired(true);
        }

        setClientData(data.data[0]);
      }
    } catch {
      console.log("error al obtener los datos");
    }
  };

  const handleDeleteFile = (id) => {
    setFiles(files.filter((file) => file.id !== id));
  };

  const handleFilesChange = (selectedFiles) => {
    //console.log(selectedFiles);
    setFiles(selectedFiles);
  };

  const handleUpload = async () => {
    //console.log(files);

    console.log({ selection });

    if (selection) {
      setShowLoader(true);

      const url = "https://store.lenken.com.ar/lenkenapi/cotizador/upload";

      const formData = new FormData();

      for (let file of files) {
        formData.append("files", file.file);
      }

      formData.append("hash", hash);
      formData.append("selection", selection);

      const response = await fetch(url, {
        method: "POST",
        body: formData,
        credentials: "include",
      });

      const data = await response.json();

      setShowLoader(false);

      if (response.status === 200) {
        //OK
        Swal.fire({
          text: data.message,
          icon: "success",
          type: "success",
        }).then(function () {
          window.location = "https://store.lenken.com.ar/"; //cambiar redirect a home de cada empresa
        });
      } else {
        //Error
        Swal.fire({
          text: data.message,
          icon: "error",
        });
      }
    } else {
      Swal.fire({
        text: "Debe seleccionar fecha y hora para poder confirmar su turno",
        icon: "error",
      });
    }
  };

  return {
    clientData,
    handleUpload,
    handleFilesChange,
    handleDeleteFile,
    files,
    showLoader,
    isExpired,
  };
}
